import { IgBetaBadge } from "@intelligems/ig-theme/IgBetaBadge";
import { List } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { IntegrationsNavLogos } from "@src/components/Navigation/BaseSideNav/IntegrationsNavLogos";
import { SectionHeader } from "@src/components/Navigation/BaseSideNav/SectionHeader";
import { StandardRoutes } from "@src/components/Utils/routes";
import { useIsAgenticLogicEnabled } from "@src/hooks/feature-flags/useIsAgenticLogicEnabled";

interface StoreManagementSectionProps {
  drawerOpen: boolean;
}

export const StoreManagementSection = ({
  drawerOpen,
}: StoreManagementSectionProps) => {
  const viewNewAnalytics = useConfiguration("view_analytics");
  const agenticLogicEnabled = useIsAgenticLogicEnabled();

  return (
    <List sx={{ px: drawerOpen ? 2 : 4, paddingTop: drawerOpen ? 0 : 2 }}>
      <SectionHeader title="Store management" drawerOpen={drawerOpen} />
      {agenticLogicEnabled && (
        <IgListItemLink
          drawerOpen={drawerOpen}
          Route={StandardRoutes().rules}
          hasAccess={true}
          chip={<IgBetaBadge variant="solid" />}
        />
      )}
      {viewNewAnalytics?.value && (
        <IgListItemLink
          drawerOpen={drawerOpen}
          Route={StandardRoutes().eventsManager}
          hasAccess={true}
          exact={true}
        />
      )}
      <IgListItemLink
        hasAccess={true}
        drawerOpen={drawerOpen}
        Route={StandardRoutes().widgetLibrary}
      />
      <IgListItemLink
        hasAccess={true}
        drawerOpen={drawerOpen}
        Route={StandardRoutes().integrations}
        endAdornment={<IntegrationsNavLogos />}
      />
    </List>
  );
};
